<template>
  <div class="manage-content">
    <div class="location">企业管理中心 / 充值</div>
    <div class="white-bg shadow margin-top-20 padding30 radius">
      <recharge-payment :list="list"></recharge-payment>
    </div>
  </div>
</template>
<script>
import {rechargePrice} from '@/config/api.js'
import axios from 'axios'
import RechargePayment from './components/RechargePayment'
export default {
  name: 'Recharge',
  components: {
    RechargePayment
  },
  data () {
    return {
      list: []
    }
  },
  methods: {
    getRecharge () {
      axios.get(rechargePrice)
              .then(res => {
                let data = res.data;
                this.list = data.data.list;
              })
              .catch(err => {
                window.console.log(err)
              })
    }
  },
  mounted() {
    this.getRecharge();
  }
}
</script>
<style>
  .el-radio-button{margin-right: 20px;margin-bottom:20px;}
  .el-radio-button__inner{padding:25px 0;border:1px #eee solid;border-radius: 4px;}
  .el-radio-button:first-child .el-radio-button__inner{border-radius: 4px;}
  .select-click .is-active .el-radio-button__inner .item .estimate{color:#fff;}
  .select-payment .el-radio{margin-right:20px;}
  .select-payment .el-radio.is-bordered + .el-radio.is-bordered{margin-left:0;}
</style>
